import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { UserDataService } from '../../../shared/services/auth/userData.service';
declare var initFlowbite: any;

@Component({
  selector: 'small-sidebar',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule,
    RouterLink
  ],
  templateUrl: './small-sidebar.component.html',
  styleUrl: './small-sidebar.component.css'
})
export class SmallSidebarComponent {
  icons = Icons;
  pageRoute: string = '';

  @Input() sidebarStatus: string = '';  
  @Output() sidebarStatusChange = new EventEmitter<string>();

  constructor(
      @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {    
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("assess_building_id")) { // get building Id from local storage
        const buildingId = localStorage.getItem("assess_building_id");
        this.userDataService.setBuildingId(buildingId + ""); // set building Id from local storage
      }
    }

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updatePageRoute();
    });
    this.updatePageRoute();
    initFlowbite();
  }

  private updatePageRoute() {
    this.pageRoute = this.activatedRoute.snapshot.firstChild?.routeConfig?.path ?? this.router.url.split('/')[1];
  }
  
  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }

  toggleSidebar(): void {
    this.sidebarStatus = this.sidebarStatus === 'small' ? 'large' : 'small';
    this.sidebarStatusChange.emit(this.sidebarStatus);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.pageRoute = this.activatedRoute.snapshot.firstChild?.routeConfig?.path ?? '';
    });
  }
}
